const isFetching = key => state => state.app[key] && state.app[key].isFetching;

const isPersonalDetailsFetching = state =>
  Boolean(isFetching('user')(state) || isFetching('userAddress')(state));

export default {
  isFetching,
  isPersonalDetailsFetching,
};
